import React, { useContext, useState } from 'react';
import { View as RNView, StyleProp, ViewStyle } from 'react-native';
import { View } from '@shared/components/View';
import { MBCardChannelProvider } from '@shared/components/blocks/contexts/channel';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext } from '@shared/styles';
import { useNavigator } from '@shared/util/navigation';
import { useCard } from '../../hooks';
import { HiddenCardOptions, useOpenCardOptionsMenu } from '../useOpenCardOptionsMenu';
import { CardExport } from './CardExport';
import { ShareSheet } from './ShareSheet';

interface Props {
  cardId: string;
  channelSlug: string;
  hiddenCardOptions?: HiddenCardOptions;
  style?: StyleProp<ViewStyle>;
}

export function MBCardDetailsOptionsButton({ cardId, channelSlug, ...props }: Props) {
  const { card } = useCard(cardId);
  return (
    <MBCardChannelProvider channelSlug={channelSlug}>
      {card && <CardDetailsOptionsButton {...{ card, ...props }} />}
    </MBCardChannelProvider>
  );
}

interface CardDetailsOptionsButtonProps extends Pick<Props, 'style' | 'hiddenCardOptions'> {
  card: MBAPI.Card;
}

function CardDetailsOptionsButton({
  card,
  style,
  hiddenCardOptions,
}: CardDetailsOptionsButtonProps) {
  const colors = useContext(ColorThemeContext);
  const { goBack } = useNavigator();
  const [showShareSheet, setShowShareSheet] = useState(false);
  const [showDownloadSheet, setShowDownloadSheet] = useState(false);
  const anchorName = `--card-details-options-${card.id}`;

  const onPress = useOpenCardOptionsMenu(card, {
    onRemoved: goBack,
    hiddenCardOptions,
    onShare: () => setShowShareSheet(true),
    onDownload: () => setShowDownloadSheet(true),
  });

  return (
    <View>
      <MBTouchableOpacity onPress={onPress}>
        <View style={{ anchorName }}>
          <RNView style={style}>
            <MBIconV2 color={colors.foregroundActive} name="dots" />
          </RNView>
        </View>
      </MBTouchableOpacity>
      {showShareSheet && (
        <ShareSheet
          anchorName={anchorName}
          card={card}
          onCloseSheet={() => setShowShareSheet(false)}
        />
      )}
      {showDownloadSheet && (
        <CardExport
          anchorName={anchorName}
          card={card}
          onCloseSheet={() => setShowDownloadSheet(false)}
        />
      )}
    </View>
  );
}
